import * as React from 'react';
import type { ClassNameProp } from '@utils';
import { cn } from '@utils';
import { amenityIconByKey } from '../amenity-icon-registry';
import type { AmenityItem } from '../types/amenity-icon.type';

interface AmenityIconProps extends ClassNameProp {
	amenity: AmenityItem;
}

/**
 * Renders an amenity icon from the static registry keyed by amenity.icon.
 */
export const AmenityIcon: React.FC<AmenityIconProps> = ({
	amenity,
	className,
}: AmenityIconProps): JSX.Element | null => {
	const Component = amenityIconByKey[amenity.icon];

	if (!Component) {
		return null;
	}

	return <Component className={cn(className)} data-testid="amenity-icon" />;
};
